import { tVariants } from '../../style-system';
import { factoryStyleProps } from '../../style-system/factory/style-props';

export const gridStyles = tVariants(
    {
        base: 'grid grid-cols-12 gap-1',
        variants: {
            dense: {
                true: 'grid-flow-row-dense',
            },
            contentType: {
                prose: 'max-w-[800px]',
                'prose-md': 'max-w-[1024px]',
                'prose-lg': 'max-w-[1440px]',
                dashboard: 'w-full max-w-[1440px]',
                'dashboard-lg': 'max-w-full w-full',
            },
            center: 'mx-auto',
            gap: factoryStyleProps.space.gap,
            ...factoryStyleProps.__atoms.space.padding,
            ...factoryStyleProps.__atoms.layout.flex,
            ...factoryStyleProps.__atoms.space.margin,
        },
    },
    {
        responsiveVariants: true,
    },
);

export const gridSubgridStyles = tVariants(
    {
        base: 'grid grid-cols-subgrid grid-rows-subgrid',
        variants: {
            ...factoryStyleProps.layout,
            ...factoryStyleProps.space,
        },
    },
    {
        responsiveVariants: true,
    },
);

export const gridColStyles = tVariants(
    {
        variants: {
            ...factoryStyleProps.layout,
            ...factoryStyleProps.space,
        },
    },
    {
        responsiveVariants: true,
    },
);
